// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { deleteV1BusinessPartnerCurrentChange, deleteV1BusinessPartnerCurrentRequestChangeOwnership, deleteV1IdentityCurrentRequestBusinessPartnerById, deleteV1RequestBusinessPartnerById, deleteV1ServiceAgreementById, getV1BusinessPartnerCurrent, getV1BusinessPartnerCurrentChange, getV1BusinessPartnerCurrentDivisions, getV1BusinessPartnerCurrentMigrationCandidateUserById, getV1BusinessPartnerCurrentMigrationCandidateUsers, getV1BusinessPartnerCurrentRequestChangeOwnership, getV1BusinessPartners, getV1CustomerByCustomerNumber, getV1Customers, getV1IdentityCurrentMigrationCandidateBusinessPartnerById, getV1IdentityCurrentMigrationCandidateBusinessPartners, getV1IdentityCurrentRequestBusinessPartnerById, getV1IdentityCurrentRequestBusinessPartners, getV1MigrationCandidateBusinessPartnerById, getV1MigrationCandidateBusinessPartners, getV1ProductLines, getV1Providers, getV1RequestBusinessPartnerById, getV1RequestBusinessPartnerDivisions, getV1RequestBusinessPartnerProxies, getV1RequestChangeOwnershipById, getV1RolesCurrent, getV1ServiceAgreementById, getV1ServiceAgreementsWithCustomer, getV1ServiceAgreementsWithProvider, type Options, postV1AddressSuggest, postV1BusinessPartnerCurrentMigrationCandidateUserByIdAccept, postV1BusinessPartnerCurrentMigrationCandidateUserByIdReject, postV1BusinessPartnerCurrentRequestChangeOwnership, postV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAccept, postV1IdentityCurrentMigrationCandidateBusinessPartnerByIdReject, postV1IdentityCurrentRequestBusinessPartner, postV1MigrationCandidateBusinessPartnerByIdAccept, postV1MigrationCandidateBusinessPartnerByIdReject, postV1RequestBusinessPartnerByIdAccept, postV1RequestBusinessPartnerByIdDecline, postV1RequestBusinessPartnerByIdRegistrationToken, postV1RequestBusinessPartnerDivision, postV1RequestBusinessPartnerProxy, postV1RequestChangeOwnershipByIdAccept, postV1ServiceAgreementByIdAccept, postV1ServiceAgreementByIdDecline, postV1ServiceAgreementWithCustomer, postV1ServiceAgreementWithProvider, putV1BusinessPartnerCurrentChange, putV1IdentityCurrentRequestBusinessPartnerById, putV1RequestBusinessPartnerById, putV1ServiceAgreementById } from '../sdk.gen';
import type { DeleteV1BusinessPartnerCurrentChangeData, DeleteV1BusinessPartnerCurrentChangeResponse, DeleteV1BusinessPartnerCurrentRequestChangeOwnershipData, DeleteV1BusinessPartnerCurrentRequestChangeOwnershipResponse, DeleteV1IdentityCurrentRequestBusinessPartnerByIdData, DeleteV1IdentityCurrentRequestBusinessPartnerByIdResponse, DeleteV1RequestBusinessPartnerByIdData, DeleteV1RequestBusinessPartnerByIdResponse, DeleteV1ServiceAgreementByIdData, DeleteV1ServiceAgreementByIdResponse, GetV1BusinessPartnerCurrentChangeData, GetV1BusinessPartnerCurrentChangeResponse, GetV1BusinessPartnerCurrentData, GetV1BusinessPartnerCurrentDivisionsData, GetV1BusinessPartnerCurrentDivisionsResponse, GetV1BusinessPartnerCurrentMigrationCandidateUserByIdData, GetV1BusinessPartnerCurrentMigrationCandidateUserByIdResponse, GetV1BusinessPartnerCurrentMigrationCandidateUsersData, GetV1BusinessPartnerCurrentMigrationCandidateUsersResponse, GetV1BusinessPartnerCurrentRequestChangeOwnershipData, GetV1BusinessPartnerCurrentRequestChangeOwnershipResponse, GetV1BusinessPartnerCurrentResponse, GetV1BusinessPartnersData, GetV1BusinessPartnersResponse, GetV1CustomerByCustomerNumberData, GetV1CustomerByCustomerNumberResponse, GetV1CustomersData, GetV1CustomersResponse, GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdData, GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdResponse, GetV1IdentityCurrentMigrationCandidateBusinessPartnersData, GetV1IdentityCurrentMigrationCandidateBusinessPartnersResponse, GetV1IdentityCurrentRequestBusinessPartnerByIdData, GetV1IdentityCurrentRequestBusinessPartnerByIdResponse, GetV1IdentityCurrentRequestBusinessPartnersData, GetV1IdentityCurrentRequestBusinessPartnersResponse, GetV1MigrationCandidateBusinessPartnerByIdData, GetV1MigrationCandidateBusinessPartnerByIdResponse, GetV1MigrationCandidateBusinessPartnersData, GetV1MigrationCandidateBusinessPartnersResponse, GetV1ProductLinesData, GetV1ProductLinesResponse, GetV1ProvidersData, GetV1ProvidersResponse, GetV1RequestBusinessPartnerByIdData, GetV1RequestBusinessPartnerByIdResponse, GetV1RequestBusinessPartnerDivisionsData, GetV1RequestBusinessPartnerDivisionsResponse, GetV1RequestBusinessPartnerProxiesData, GetV1RequestBusinessPartnerProxiesResponse, GetV1RequestChangeOwnershipByIdData, GetV1RequestChangeOwnershipByIdResponse, GetV1RolesCurrentData, GetV1RolesCurrentResponse, GetV1ServiceAgreementByIdData, GetV1ServiceAgreementByIdResponse, GetV1ServiceAgreementsWithCustomerData, GetV1ServiceAgreementsWithCustomerResponse, GetV1ServiceAgreementsWithProviderData, GetV1ServiceAgreementsWithProviderResponse, PostV1AddressSuggestData, PostV1AddressSuggestResponse, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptData, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptResponse, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectData, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectResponse, PostV1BusinessPartnerCurrentRequestChangeOwnershipData, PostV1BusinessPartnerCurrentRequestChangeOwnershipResponse, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptData, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptResponse, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectData, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectResponse, PostV1IdentityCurrentRequestBusinessPartnerData, PostV1MigrationCandidateBusinessPartnerByIdAcceptData, PostV1MigrationCandidateBusinessPartnerByIdAcceptResponse, PostV1MigrationCandidateBusinessPartnerByIdRejectData, PostV1MigrationCandidateBusinessPartnerByIdRejectResponse, PostV1RequestBusinessPartnerByIdAcceptData, PostV1RequestBusinessPartnerByIdAcceptResponse, PostV1RequestBusinessPartnerByIdDeclineData, PostV1RequestBusinessPartnerByIdDeclineResponse, PostV1RequestBusinessPartnerByIdRegistrationTokenData, PostV1RequestBusinessPartnerByIdRegistrationTokenResponse, PostV1RequestBusinessPartnerDivisionData, PostV1RequestBusinessPartnerProxyData, PostV1RequestBusinessPartnerProxyResponse, PostV1RequestChangeOwnershipByIdAcceptData, PostV1ServiceAgreementByIdAcceptData, PostV1ServiceAgreementByIdAcceptResponse, PostV1ServiceAgreementByIdDeclineData, PostV1ServiceAgreementByIdDeclineResponse, PostV1ServiceAgreementWithCustomerData, PostV1ServiceAgreementWithCustomerResponse, PostV1ServiceAgreementWithProviderData, PostV1ServiceAgreementWithProviderResponse, PutV1BusinessPartnerCurrentChangeData, PutV1IdentityCurrentRequestBusinessPartnerByIdData, PutV1IdentityCurrentRequestBusinessPartnerByIdResponse, PutV1RequestBusinessPartnerByIdData, PutV1RequestBusinessPartnerByIdResponse, PutV1ServiceAgreementByIdData, PutV1ServiceAgreementByIdResponse } from '../types.gen';

/**
 * Get a list of addresses from the address suggestion service
 *
 *  Get a list of addresses from the address suggestion service. <hr /> <br /> <br /> Must be authenticated. <br /> <br /> These values match business partner address, but are not required. <br /> If a lat/lng is available from a user geo lookup, supply that. <br /> If not supplied, lat/lng will default to the central US, unless a Country, StateProvinceRegion, or City is supplied. <br /> Prefer lat/lng, unless the user changes their country, from the geo lookup value.
 */
export const postV1AddressSuggestMutation = (options?: Partial<Options<PostV1AddressSuggestData>>): UseMutationOptions<PostV1AddressSuggestResponse, DefaultError, Options<PostV1AddressSuggestData>> => {
    const mutationOptions: UseMutationOptions<PostV1AddressSuggestResponse, DefaultError, Options<PostV1AddressSuggestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1AddressSuggest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getV1BusinessPartnerCurrentQueryKey = (options?: Options<GetV1BusinessPartnerCurrentData>) => createQueryKey('getV1BusinessPartnerCurrent', options);

/**
 * Get current business partner
 *
 *  Get the business partner for current token. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**.
 */
export const getV1BusinessPartnerCurrentOptions = (options?: Options<GetV1BusinessPartnerCurrentData>) => queryOptions<GetV1BusinessPartnerCurrentResponse, DefaultError, GetV1BusinessPartnerCurrentResponse, ReturnType<typeof getV1BusinessPartnerCurrentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1BusinessPartnerCurrent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1BusinessPartnerCurrentQueryKey(options)
});

/**
 * Delete change for current business partner
 *
 *  Deletes pending change request for current business partner. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If there is already a pending change with status `accepted`, responds with HTTP status **409**. <br /> If there is no current change request for current business partner, responds with HTTP status **404**.
 */
export const deleteV1BusinessPartnerCurrentChangeMutation = (options?: Partial<Options<DeleteV1BusinessPartnerCurrentChangeData>>): UseMutationOptions<DeleteV1BusinessPartnerCurrentChangeResponse, DefaultError, Options<DeleteV1BusinessPartnerCurrentChangeData>> => {
    const mutationOptions: UseMutationOptions<DeleteV1BusinessPartnerCurrentChangeResponse, DefaultError, Options<DeleteV1BusinessPartnerCurrentChangeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1BusinessPartnerCurrentChange({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1BusinessPartnerCurrentChangeQueryKey = (options?: Options<GetV1BusinessPartnerCurrentChangeData>) => createQueryKey('getV1BusinessPartnerCurrentChange', options);

/**
 * Get change request for current business partner
 *
 *  Get pending change details request for current business partner. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If no pending change exists, responds with HTTP status **404**. <br /> <br /> If responds with HTTP status **200**, the change request is either `pending` or `accepted`. <br /> <br /> An `accepted` change request will promptly be applied to current business partner and then deleted.
 */
export const getV1BusinessPartnerCurrentChangeOptions = (options?: Options<GetV1BusinessPartnerCurrentChangeData>) => queryOptions<GetV1BusinessPartnerCurrentChangeResponse, DefaultError, GetV1BusinessPartnerCurrentChangeResponse, ReturnType<typeof getV1BusinessPartnerCurrentChangeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1BusinessPartnerCurrentChange({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1BusinessPartnerCurrentChangeQueryKey(options)
});

/**
 * Put change request for current business partner
 *
 *  Upsert a request to change details about current business partner. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If there is already a pending change being applied, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **202** and the change request is either `pending` or `accepted`. <br /> <br /> An `accepted` change request will promptly be applied to current business partner and then deleted. A `pending` is due to potential duplicates and will be reviewed by Topcon. <br /> <br /> Notifications will be generated informing progress of the change request.
 */
export const putV1BusinessPartnerCurrentChangeMutation = (options?: Partial<Options<PutV1BusinessPartnerCurrentChangeData>>): UseMutationOptions<unknown, DefaultError, Options<PutV1BusinessPartnerCurrentChangeData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PutV1BusinessPartnerCurrentChangeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putV1BusinessPartnerCurrentChange({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1BusinessPartnerCurrentDivisionsQueryKey = (options?: Options<GetV1BusinessPartnerCurrentDivisionsData>) => createQueryKey('getV1BusinessPartnerCurrentDivisions', options);

/**
 * List divisions of current business partner
 *
 *  List all divisions of current business partner. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner type isn't `topcon`, `dealer` or `end_customer_enterprise`, responds with HTTP status **403**.
 */
export const getV1BusinessPartnerCurrentDivisionsOptions = (options?: Options<GetV1BusinessPartnerCurrentDivisionsData>) => queryOptions<GetV1BusinessPartnerCurrentDivisionsResponse, DefaultError, GetV1BusinessPartnerCurrentDivisionsResponse, ReturnType<typeof getV1BusinessPartnerCurrentDivisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1BusinessPartnerCurrentDivisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1BusinessPartnerCurrentDivisionsQueryKey(options)
});

export const getV1BusinessPartnerCurrentMigrationCandidateUserByIdQueryKey = (options: Options<GetV1BusinessPartnerCurrentMigrationCandidateUserByIdData>) => createQueryKey('getV1BusinessPartnerCurrentMigrationCandidateUserById', options);

/**
 * Get migration candidate user
 *
 *  Get a specific migration candidate user. <hr /> <br /> <br /> Must have `bp_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the id is not a UUID, responds with HTTP status **400**. <br /> If the migration candidate user is not pending, doesn't exist, is not for the current business partner, or its business partner candidate is not matched or accepted, responds with HTTP status **404**.
 */
export const getV1BusinessPartnerCurrentMigrationCandidateUserByIdOptions = (options: Options<GetV1BusinessPartnerCurrentMigrationCandidateUserByIdData>) => queryOptions<GetV1BusinessPartnerCurrentMigrationCandidateUserByIdResponse, DefaultError, GetV1BusinessPartnerCurrentMigrationCandidateUserByIdResponse, ReturnType<typeof getV1BusinessPartnerCurrentMigrationCandidateUserByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1BusinessPartnerCurrentMigrationCandidateUserById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1BusinessPartnerCurrentMigrationCandidateUserByIdQueryKey(options)
});

/**
 * Accept migration candidate user
 *
 *  Accept a migration candidate user. <hr /> <br /> <br /> Must have `bp_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the id is not a UUID, responds with HTTP status **400**. <br /> If the migration candidate user is not pending, doesn't exist, is not for the current business partner, or its business partner candidate is not matched or accepted, responds with HTTP status **404**. <br /> On success, responds with HTTP status **204**. The migration candidate user status transitions to 'accepted'. <br /> After the status transition, Directus best-effort processing creates a user when an identity with the canonical email exists, or an invite to join otherwise. An existing user or invite for the business partner satisfies this processing.
 */
export const postV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptMutation = (options?: Partial<Options<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptData>>): UseMutationOptions<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptResponse, DefaultError, Options<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptData>> => {
    const mutationOptions: UseMutationOptions<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptResponse, DefaultError, Options<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1BusinessPartnerCurrentMigrationCandidateUserByIdAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject migration candidate user
 *
 *  Reject a migration candidate user. <hr /> <br /> <br /> Must have `bp_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the id is not a UUID, responds with HTTP status **400**. <br /> If the migration candidate user is not pending, doesn't exist, is not for the current business partner, or its business partner candidate is not matched or accepted, responds with HTTP status **404**. <br /> On success, responds with HTTP status **204**. The migration candidate user status transitions to 'rejected'. No user or invite is created.
 */
export const postV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectMutation = (options?: Partial<Options<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectData>>): UseMutationOptions<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectResponse, DefaultError, Options<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectData>> => {
    const mutationOptions: UseMutationOptions<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectResponse, DefaultError, Options<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1BusinessPartnerCurrentMigrationCandidateUserByIdReject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1BusinessPartnerCurrentMigrationCandidateUsersQueryKey = (options?: Options<GetV1BusinessPartnerCurrentMigrationCandidateUsersData>) => createQueryKey('getV1BusinessPartnerCurrentMigrationCandidateUsers', options);

/**
 * List migration candidate users
 *
 *  List migration candidate users requiring action for current business partner. <hr /> <br /> <br /> Migration candidate users represent suggested users to be added to the business partner from external system imports. Returns pending user candidates for migration candidate business partners that are matched or accepted and linked to the current business partner. Accepted and rejected user candidates, and users whose business partner candidate is not actionable, are excluded and retained for audit. <br /> <br /> Must have `bp_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**.
 */
export const getV1BusinessPartnerCurrentMigrationCandidateUsersOptions = (options?: Options<GetV1BusinessPartnerCurrentMigrationCandidateUsersData>) => queryOptions<GetV1BusinessPartnerCurrentMigrationCandidateUsersResponse, DefaultError, GetV1BusinessPartnerCurrentMigrationCandidateUsersResponse, ReturnType<typeof getV1BusinessPartnerCurrentMigrationCandidateUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1BusinessPartnerCurrentMigrationCandidateUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1BusinessPartnerCurrentMigrationCandidateUsersQueryKey(options)
});

/**
 * Cancels the current change ownership request for the current business partner
 *
 *  Cancels the current change ownership request for the current business partner <br /> Requires bp_owner role, otherwise response with HTTP status 403 <br /> If there is no current request to change ownership, responds with HTTP status **404**
 */
export const deleteV1BusinessPartnerCurrentRequestChangeOwnershipMutation = (options?: Partial<Options<DeleteV1BusinessPartnerCurrentRequestChangeOwnershipData>>): UseMutationOptions<DeleteV1BusinessPartnerCurrentRequestChangeOwnershipResponse, DefaultError, Options<DeleteV1BusinessPartnerCurrentRequestChangeOwnershipData>> => {
    const mutationOptions: UseMutationOptions<DeleteV1BusinessPartnerCurrentRequestChangeOwnershipResponse, DefaultError, Options<DeleteV1BusinessPartnerCurrentRequestChangeOwnershipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1BusinessPartnerCurrentRequestChangeOwnership({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1BusinessPartnerCurrentRequestChangeOwnershipQueryKey = (options?: Options<GetV1BusinessPartnerCurrentRequestChangeOwnershipData>) => createQueryKey('getV1BusinessPartnerCurrentRequestChangeOwnership', options);

/**
 * Get the current change ownership request for the current business partner
 *
 *  Get the current change ownership request for the current business partner <br /> Requires bp_owner role, otherwise responds with HTTP status **403** <br /> If there is no current request to change ownership, responds with HTTP status **404** <br /> There can only be one change ownership request per business partner <br /> If the current business partner is of type Topcon or Dealer, responds with HTTP status **409**
 */
export const getV1BusinessPartnerCurrentRequestChangeOwnershipOptions = (options?: Options<GetV1BusinessPartnerCurrentRequestChangeOwnershipData>) => queryOptions<GetV1BusinessPartnerCurrentRequestChangeOwnershipResponse, DefaultError, GetV1BusinessPartnerCurrentRequestChangeOwnershipResponse, ReturnType<typeof getV1BusinessPartnerCurrentRequestChangeOwnershipQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1BusinessPartnerCurrentRequestChangeOwnership({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1BusinessPartnerCurrentRequestChangeOwnershipQueryKey(options)
});

/**
 * Create an ownership request for the current business partner
 *
 *  Create a change ownership request for the current business partner <br /> Requires bp_owner role, otherwise response with HTTP status 403 <br /> If there is a current request to change ownership, responds with HTTP status **409** <br /> If the email specified is already an owner of a business partner, or a pending request business partner, responds with HTTP status 409 <br> If the current business partner is of type Topcon or Dealer, responds with HTTP status **409**
 */
export const postV1BusinessPartnerCurrentRequestChangeOwnershipMutation = (options?: Partial<Options<PostV1BusinessPartnerCurrentRequestChangeOwnershipData>>): UseMutationOptions<PostV1BusinessPartnerCurrentRequestChangeOwnershipResponse, DefaultError, Options<PostV1BusinessPartnerCurrentRequestChangeOwnershipData>> => {
    const mutationOptions: UseMutationOptions<PostV1BusinessPartnerCurrentRequestChangeOwnershipResponse, DefaultError, Options<PostV1BusinessPartnerCurrentRequestChangeOwnershipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1BusinessPartnerCurrentRequestChangeOwnership({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1BusinessPartnersQueryKey = (options?: Options<GetV1BusinessPartnersData>) => createQueryKey('getV1BusinessPartners', options);

/**
 * Get business partners
 *
 *  Get business partners. <hr />
 */
export const getV1BusinessPartnersOptions = (options?: Options<GetV1BusinessPartnersData>) => queryOptions<GetV1BusinessPartnersResponse, DefaultError, GetV1BusinessPartnersResponse, ReturnType<typeof getV1BusinessPartnersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1BusinessPartners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1BusinessPartnersQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getV1BusinessPartnersInfiniteQueryKey = (options?: Options<GetV1BusinessPartnersData>): QueryKey<Options<GetV1BusinessPartnersData>> => createQueryKey('getV1BusinessPartners', options, true);

/**
 * Get business partners
 *
 *  Get business partners. <hr />
 */
export const getV1BusinessPartnersInfiniteOptions = (options?: Options<GetV1BusinessPartnersData>) => {
    const opts = infiniteQueryOptions<GetV1BusinessPartnersResponse, DefaultError, InfiniteData<GetV1BusinessPartnersResponse>, QueryKey<Options<GetV1BusinessPartnersData>>, number | Pick<QueryKey<Options<GetV1BusinessPartnersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1BusinessPartnersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1BusinessPartners({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1BusinessPartnersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getV1CustomerByCustomerNumberQueryKey = (options: Options<GetV1CustomerByCustomerNumberData>) => createQueryKey('getV1CustomerByCustomerNumber', options);

/**
 * Get customer
 *
 *  Get customer by 12-digit customer number. <hr /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**.
 */
export const getV1CustomerByCustomerNumberOptions = (options: Options<GetV1CustomerByCustomerNumberData>) => queryOptions<GetV1CustomerByCustomerNumberResponse, DefaultError, GetV1CustomerByCustomerNumberResponse, ReturnType<typeof getV1CustomerByCustomerNumberQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1CustomerByCustomerNumber({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CustomerByCustomerNumberQueryKey(options)
});

export const getV1CustomersQueryKey = (options?: Options<GetV1CustomersData>) => createQueryKey('getV1Customers', options);

/**
 * Get customers
 *
 *  Get customers. Deprecated, use "/v1/customer/{customerNumber}". <hr /> <br /> <br /> For any results, provide at least first 5 characters including whitespace to the name filter. <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**.
 *
 * @deprecated
 */
export const getV1CustomersOptions = (options?: Options<GetV1CustomersData>) => queryOptions<GetV1CustomersResponse, DefaultError, GetV1CustomersResponse, ReturnType<typeof getV1CustomersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Customers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CustomersQueryKey(options)
});

export const getV1IdentityCurrentMigrationCandidateBusinessPartnerByIdQueryKey = (options: Options<GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdData>) => createQueryKey('getV1IdentityCurrentMigrationCandidateBusinessPartnerById', options);

/**
 * Get migration candidate business partner
 *
 *  Get a specific migration candidate business partner. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If the migration candidate doesn't exist or current identity's canonical email doesn't match a migration_candidate_user for this candidate, responds with HTTP status **404**.
 */
export const getV1IdentityCurrentMigrationCandidateBusinessPartnerByIdOptions = (options: Options<GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdData>) => queryOptions<GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdResponse, DefaultError, GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdResponse, ReturnType<typeof getV1IdentityCurrentMigrationCandidateBusinessPartnerByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1IdentityCurrentMigrationCandidateBusinessPartnerById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1IdentityCurrentMigrationCandidateBusinessPartnerByIdQueryKey(options)
});

/**
 * Accept (match) migration candidate business partner
 *
 *  Accept (match) a pending migration candidate business partner for the current identity. <hr /> <br /> Links the candidate to an existing business partner identified by `externalId` (a Topcon Resource Name / ext_id), sets `status` to `accepted`, and computes `service_agreement_status`: `accepted` if a service agreement already exists between the candidate's dealer (provider) and the linked business partner (customer), otherwise `pending` (the FE should then guide the user through a service agreement creation flow). <br /> <br /> Creates neither a Request Business Partner nor a Service Agreement. Operates on pending candidates only; call this endpoint to make a matching decision the import tool was not confident enough to make automatically. <br /> <br /> The `externalId` must identify a business partner that is either listed in the candidate's `matchDetails.top_targets` OR is a business partner the current identity owns or is a user member of. <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If the migration candidate doesn't exist, the current identity doesn't match a migration_candidate_user for this candidate, or the candidate is not pending, responds with HTTP status **404**. <br /> If `externalId` is missing or empty, or `externalId` is not one of the candidate's `top_targets` (and the identity-ownership path also fails), responds with HTTP status **400** or **409** respectively. <br /> If the business partner identified by `externalId` does not exist, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **200** with the updated migration candidate body including the new `status`, `businessPartner`, and `serviceAgreementStatus`.
 */
export const postV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptMutation = (options?: Partial<Options<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptData>>): UseMutationOptions<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptResponse, DefaultError, Options<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptData>> => {
    const mutationOptions: UseMutationOptions<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptResponse, DefaultError, Options<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject migration candidate business partner
 *
 *  Reject a migration candidate business partner. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If the migration candidate doesn't exist, current identity's canonical email doesn't match a migration_candidate_user for this candidate, or the candidate is neither pending nor matched with a pending service agreement, responds with HTTP status **404**. <br /> <br /> On success, responds with HTTP status **204**. A pending candidate's status transitions to 'rejected'. A candidate matched to a business partner but awaiting service agreement acceptance (status is 'matched' and service_agreement_status is 'pending') instead has its service_agreement_status transitioned to 'rejected', leaving status as 'matched'.
 */
export const postV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectMutation = (options?: Partial<Options<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectData>>): UseMutationOptions<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectResponse, DefaultError, Options<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectData>> => {
    const mutationOptions: UseMutationOptions<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectResponse, DefaultError, Options<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1IdentityCurrentMigrationCandidateBusinessPartnerByIdReject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1IdentityCurrentMigrationCandidateBusinessPartnersQueryKey = (options?: Options<GetV1IdentityCurrentMigrationCandidateBusinessPartnersData>) => createQueryKey('getV1IdentityCurrentMigrationCandidateBusinessPartners', options);

/**
 * List migration candidate business partners
 *
 *  List migration candidate business partners for current identity. <hr /> <br /> <br /> Migration candidates represent data imported from external systems. This endpoint returns only pending candidates (status = "pending") where the identity's canonical email matches a migration_candidate_user. This indicates the identity was an admin in the source system for this business partner. Accepted and rejected candidates are excluded (kept for audit and garbage collection). <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**.
 */
export const getV1IdentityCurrentMigrationCandidateBusinessPartnersOptions = (options?: Options<GetV1IdentityCurrentMigrationCandidateBusinessPartnersData>) => queryOptions<GetV1IdentityCurrentMigrationCandidateBusinessPartnersResponse, DefaultError, GetV1IdentityCurrentMigrationCandidateBusinessPartnersResponse, ReturnType<typeof getV1IdentityCurrentMigrationCandidateBusinessPartnersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1IdentityCurrentMigrationCandidateBusinessPartners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1IdentityCurrentMigrationCandidateBusinessPartnersQueryKey(options)
});

/**
 * Create a business partner request for your identity
 *
 *  Create a request for a new business partner of a customer type for current identity. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If current identity owns 3 or more root business partner already, responds with HTTP status **409**. <br /> If the stated service provider type is not `dealer`, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **201** and the business partner request is `accepted`. <br /> <br /> Notifications will be generated informing progress of the business partner request for the service provider and identity. <br /> <br /> A business partner request with status `accepted` will promptly change status to `done` and a new business partner and service agreement with the service provider will be created. The new service agreement will require consent from the service provider. <br /> <br /> A business partner request with status `rejected` will remain until deleted by the identity or garbage collected. Requests are rejected if they appear to be duplicates. Rejected requests may be updated with new details to try again. <br /> <br /> Optionally supply `migrationCandidateBusinessPartnerId` to accept a migration candidate business partner. When supplied, the new business partner request is linked to that candidate and the candidate is accepted as a side effect. Omit it for an ordinary self-service request.
 */
export const postV1IdentityCurrentRequestBusinessPartnerMutation = (options?: Partial<Options<PostV1IdentityCurrentRequestBusinessPartnerData>>): UseMutationOptions<unknown, DefaultError, Options<PostV1IdentityCurrentRequestBusinessPartnerData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostV1IdentityCurrentRequestBusinessPartnerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1IdentityCurrentRequestBusinessPartner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete own particular business partner request
 *
 *  Delete a business partner request owned by current identity. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If the business partner request doesn't exist or current identity is not the owner, responds with HTTP status **404**. <br /> If the business partner request status is not `rejected`, `done` or `closed`, responds with HTTP status 409. <br /> (you can't delete a request while it is being processed).
 */
export const deleteV1IdentityCurrentRequestBusinessPartnerByIdMutation = (options?: Partial<Options<DeleteV1IdentityCurrentRequestBusinessPartnerByIdData>>): UseMutationOptions<DeleteV1IdentityCurrentRequestBusinessPartnerByIdResponse, DefaultError, Options<DeleteV1IdentityCurrentRequestBusinessPartnerByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteV1IdentityCurrentRequestBusinessPartnerByIdResponse, DefaultError, Options<DeleteV1IdentityCurrentRequestBusinessPartnerByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1IdentityCurrentRequestBusinessPartnerById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1IdentityCurrentRequestBusinessPartnerByIdQueryKey = (options: Options<GetV1IdentityCurrentRequestBusinessPartnerByIdData>) => createQueryKey('getV1IdentityCurrentRequestBusinessPartnerById', options);

/**
 * Get own particular business partner request
 *
 *  Get a business partner request owned by current identity. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If the business partner request doesn't exist or current identity is not the owner, responds with HTTP status **404**.
 */
export const getV1IdentityCurrentRequestBusinessPartnerByIdOptions = (options: Options<GetV1IdentityCurrentRequestBusinessPartnerByIdData>) => queryOptions<GetV1IdentityCurrentRequestBusinessPartnerByIdResponse, DefaultError, GetV1IdentityCurrentRequestBusinessPartnerByIdResponse, ReturnType<typeof getV1IdentityCurrentRequestBusinessPartnerByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1IdentityCurrentRequestBusinessPartnerById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1IdentityCurrentRequestBusinessPartnerByIdQueryKey(options)
});

/**
 * Update own particular business partner request
 *
 *  Update a business partner request owned by current identity. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If the business partner request doesn't exist or current identity is not the owner, responds with HTTP status **404**. <br /> If the business partner request status is not `rejected` or `customer_review`, responds with HTTP status **409**. <br /> <br /> On success, if business partner request was `rejected`, responds with HTTP status **202** and the status is `accepted` and the request is in progress again.
 */
export const putV1IdentityCurrentRequestBusinessPartnerByIdMutation = (options?: Partial<Options<PutV1IdentityCurrentRequestBusinessPartnerByIdData>>): UseMutationOptions<PutV1IdentityCurrentRequestBusinessPartnerByIdResponse, DefaultError, Options<PutV1IdentityCurrentRequestBusinessPartnerByIdData>> => {
    const mutationOptions: UseMutationOptions<PutV1IdentityCurrentRequestBusinessPartnerByIdResponse, DefaultError, Options<PutV1IdentityCurrentRequestBusinessPartnerByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putV1IdentityCurrentRequestBusinessPartnerById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1IdentityCurrentRequestBusinessPartnersQueryKey = (options?: Options<GetV1IdentityCurrentRequestBusinessPartnersData>) => createQueryKey('getV1IdentityCurrentRequestBusinessPartners', options);

/**
 * List own business partner requests
 *
 *  List all business partner requests owned by current identity. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**.
 */
export const getV1IdentityCurrentRequestBusinessPartnersOptions = (options?: Options<GetV1IdentityCurrentRequestBusinessPartnersData>) => queryOptions<GetV1IdentityCurrentRequestBusinessPartnersResponse, DefaultError, GetV1IdentityCurrentRequestBusinessPartnersResponse, ReturnType<typeof getV1IdentityCurrentRequestBusinessPartnersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1IdentityCurrentRequestBusinessPartners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1IdentityCurrentRequestBusinessPartnersQueryKey(options)
});

export const getV1MigrationCandidateBusinessPartnerByIdQueryKey = (options: Options<GetV1MigrationCandidateBusinessPartnerByIdData>) => createQueryKey('getV1MigrationCandidateBusinessPartnerById', options);

/**
 * Get migration candidate business partner
 *
 *  Get a specific migration candidate business partner for the current dealer business partner. <hr /> <br /> <br /> Only candidates that still require dealer action are returned: either the candidate itself is pending (status = "pending"), or the candidate has been accepted/matched to a business partner but its service agreement is still pending (status in ["accepted", "matched"] and service_agreement_status = "pending"). <br /> <br /> Must have `sa_customer_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**. <br /> If the migration candidate doesn't exist, the dealer_business_partner_id doesn't match current business partner, or the candidate no longer requires dealer action (not pending and not accepted/matched with a pending service agreement), responds with HTTP status **404**.
 */
export const getV1MigrationCandidateBusinessPartnerByIdOptions = (options: Options<GetV1MigrationCandidateBusinessPartnerByIdData>) => queryOptions<GetV1MigrationCandidateBusinessPartnerByIdResponse, DefaultError, GetV1MigrationCandidateBusinessPartnerByIdResponse, ReturnType<typeof getV1MigrationCandidateBusinessPartnerByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1MigrationCandidateBusinessPartnerById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1MigrationCandidateBusinessPartnerByIdQueryKey(options)
});

/**
 * Accept (match) migration candidate as dealer
 *
 *  Accept (match) a pending migration candidate business partner as the dealer. <hr /> <br /> Links the candidate to an existing business partner identified by `externalId` (a Topcon Resource Name / ext_id), sets `status` to `accepted`, and computes `service_agreement_status`: `accepted` if a service agreement already exists between the current dealer (provider) and the linked business partner (customer), otherwise `pending` (the FE should then guide the user through a service agreement creation flow). <br /> <br /> Creates neither a Request Business Partner nor a Service Agreement. Operates on pending candidates only; returns **409** if the candidate is not pending (e.g. already matched by the import tool). <br /> <br /> The `externalId` must be one of the candidate's `matchDetails.top_targets`. <br /> <br /> Must have `sa_customer_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**. <br /> If the migration candidate doesn't exist or the dealer_business_partner_id doesn't match the current business partner, responds with HTTP status **404**. <br /> If `externalId` is missing or empty, or `externalId` is not one of the candidate's `top_targets`, responds with HTTP status **400**. <br /> If the candidate is not pending, or the business partner identified by `externalId` does not exist, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **200** with the updated migration candidate body including the new `status`, `businessPartner`, and `serviceAgreementStatus`.
 */
export const postV1MigrationCandidateBusinessPartnerByIdAcceptMutation = (options?: Partial<Options<PostV1MigrationCandidateBusinessPartnerByIdAcceptData>>): UseMutationOptions<PostV1MigrationCandidateBusinessPartnerByIdAcceptResponse, DefaultError, Options<PostV1MigrationCandidateBusinessPartnerByIdAcceptData>> => {
    const mutationOptions: UseMutationOptions<PostV1MigrationCandidateBusinessPartnerByIdAcceptResponse, DefaultError, Options<PostV1MigrationCandidateBusinessPartnerByIdAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1MigrationCandidateBusinessPartnerByIdAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject migration candidate as dealer
 *
 *  Reject a migration candidate business partner as the dealer. <hr /> <br /> <br /> Must have `sa_customer_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**. <br /> If the migration candidate doesn't exist, the dealer_business_partner_id doesn't match current business partner, or the candidate is neither pending nor matched with a pending service agreement, responds with HTTP status **404**. <br /> <br /> On success, responds with HTTP status **204**. A pending candidate's status transitions to 'rejected'. A candidate matched to a business partner but awaiting service agreement acceptance (status is 'matched' and service_agreement_status is 'pending') instead has its service_agreement_status transitioned to 'rejected', leaving status as 'matched'.
 */
export const postV1MigrationCandidateBusinessPartnerByIdRejectMutation = (options?: Partial<Options<PostV1MigrationCandidateBusinessPartnerByIdRejectData>>): UseMutationOptions<PostV1MigrationCandidateBusinessPartnerByIdRejectResponse, DefaultError, Options<PostV1MigrationCandidateBusinessPartnerByIdRejectData>> => {
    const mutationOptions: UseMutationOptions<PostV1MigrationCandidateBusinessPartnerByIdRejectResponse, DefaultError, Options<PostV1MigrationCandidateBusinessPartnerByIdRejectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1MigrationCandidateBusinessPartnerByIdReject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1MigrationCandidateBusinessPartnersQueryKey = (options?: Options<GetV1MigrationCandidateBusinessPartnersData>) => createQueryKey('getV1MigrationCandidateBusinessPartners', options);

/**
 * List migration candidates for dealer
 *
 *  List migration candidate business partners for current dealer business partner. <hr /> <br /> <br /> Returns migration candidates where the dealer_business_partner_id matches the current business partner. Returns candidates that still require dealer action: either the candidate itself is pending (status = "pending"), or the candidate has been accepted/matched to a business partner but its service agreement is still pending (status in ["accepted", "matched"] and service_agreement_status = "pending"). Candidates that are fully accepted/rejected with no pending service agreement are excluded (kept for audit and garbage collection). <br /> <br /> Must have `sa_customer_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**.
 */
export const getV1MigrationCandidateBusinessPartnersOptions = (options?: Options<GetV1MigrationCandidateBusinessPartnersData>) => queryOptions<GetV1MigrationCandidateBusinessPartnersResponse, DefaultError, GetV1MigrationCandidateBusinessPartnersResponse, ReturnType<typeof getV1MigrationCandidateBusinessPartnersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1MigrationCandidateBusinessPartners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1MigrationCandidateBusinessPartnersQueryKey(options)
});

export const getV1MigrationCandidateBusinessPartnersInfiniteQueryKey = (options?: Options<GetV1MigrationCandidateBusinessPartnersData>): QueryKey<Options<GetV1MigrationCandidateBusinessPartnersData>> => createQueryKey('getV1MigrationCandidateBusinessPartners', options, true);

/**
 * List migration candidates for dealer
 *
 *  List migration candidate business partners for current dealer business partner. <hr /> <br /> <br /> Returns migration candidates where the dealer_business_partner_id matches the current business partner. Returns candidates that still require dealer action: either the candidate itself is pending (status = "pending"), or the candidate has been accepted/matched to a business partner but its service agreement is still pending (status in ["accepted", "matched"] and service_agreement_status = "pending"). Candidates that are fully accepted/rejected with no pending service agreement are excluded (kept for audit and garbage collection). <br /> <br /> Must have `sa_customer_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**.
 */
export const getV1MigrationCandidateBusinessPartnersInfiniteOptions = (options?: Options<GetV1MigrationCandidateBusinessPartnersData>) => {
    const opts = infiniteQueryOptions<GetV1MigrationCandidateBusinessPartnersResponse, DefaultError, InfiniteData<GetV1MigrationCandidateBusinessPartnersResponse>, QueryKey<Options<GetV1MigrationCandidateBusinessPartnersData>>, number | Pick<QueryKey<Options<GetV1MigrationCandidateBusinessPartnersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1MigrationCandidateBusinessPartnersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1MigrationCandidateBusinessPartners({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1MigrationCandidateBusinessPartnersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getV1ProductLinesQueryKey = (options?: Options<GetV1ProductLinesData>) => createQueryKey('getV1ProductLines', options);

/**
 * Get product lines
 *
 *  Get product lines. <hr />
 */
export const getV1ProductLinesOptions = (options?: Options<GetV1ProductLinesData>) => queryOptions<GetV1ProductLinesResponse, DefaultError, GetV1ProductLinesResponse, ReturnType<typeof getV1ProductLinesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1ProductLines({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1ProductLinesQueryKey(options)
});

export const getV1ProvidersQueryKey = (options?: Options<GetV1ProvidersData>) => createQueryKey('getV1Providers', options);

/**
 * Get service providers
 *
 *  Get service providers. <hr />
 */
export const getV1ProvidersOptions = (options?: Options<GetV1ProvidersData>) => queryOptions<GetV1ProvidersResponse, DefaultError, GetV1ProvidersResponse, ReturnType<typeof getV1ProvidersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Providers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1ProvidersQueryKey(options)
});

export const getV1ProvidersInfiniteQueryKey = (options?: Options<GetV1ProvidersData>): QueryKey<Options<GetV1ProvidersData>> => createQueryKey('getV1Providers', options, true);

/**
 * Get service providers
 *
 *  Get service providers. <hr />
 */
export const getV1ProvidersInfiniteOptions = (options?: Options<GetV1ProvidersData>) => {
    const opts = infiniteQueryOptions<GetV1ProvidersResponse, DefaultError, InfiniteData<GetV1ProvidersResponse>, QueryKey<Options<GetV1ProvidersData>>, number | Pick<QueryKey<Options<GetV1ProvidersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1ProvidersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1Providers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1ProvidersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create request for a new division
 *
 *  Create a request for a new business partner as a division of current business partner and owner being current identity. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't in the set `end_customer_enterprise`, responds with HTTP status **403**. <br /> If there are 10 or more existing business partner requests, responds with HTTP status **409**. <br /> If there are 100 or more existing divisions, responds with HTTP status **409**. <br /> If the stated service provider type is not `dealer`, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **202** and the business partner request is `accepted`. <br /> <br /> Notifications will be generated informing progress of the change request for the service provider and current identity. <br /> <br /> A business partner request with status `accepted` will promptly change status to `done` and a new business partner and service agreement with the service provider will be created. <br /> <br /> The new service agreement will require consent from the service provider. <br /> <br /> The new business partner will be a division of current business partner, and owned by current identity. <br /> <br /> A request with status `rejected` will remain until deleted by the identity or garbage collected. Requests are rejected if they appear to be duplicates. Rejected requests may be updated with new details to try again.
 */
export const postV1RequestBusinessPartnerDivisionMutation = (options?: Partial<Options<PostV1RequestBusinessPartnerDivisionData>>): UseMutationOptions<unknown, DefaultError, Options<PostV1RequestBusinessPartnerDivisionData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostV1RequestBusinessPartnerDivisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1RequestBusinessPartnerDivision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1RequestBusinessPartnerDivisionsQueryKey = (options?: Options<GetV1RequestBusinessPartnerDivisionsData>) => createQueryKey('getV1RequestBusinessPartnerDivisions', options);

/**
 * List the business partner requests for new divisions
 *
 *  Get the division business partner requests of current business partner. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `end_customer_enterprise`, responds with HTTP status **403**.
 */
export const getV1RequestBusinessPartnerDivisionsOptions = (options?: Options<GetV1RequestBusinessPartnerDivisionsData>) => queryOptions<GetV1RequestBusinessPartnerDivisionsResponse, DefaultError, GetV1RequestBusinessPartnerDivisionsResponse, ReturnType<typeof getV1RequestBusinessPartnerDivisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1RequestBusinessPartnerDivisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1RequestBusinessPartnerDivisionsQueryKey(options)
});

export const getV1RequestBusinessPartnerProxiesQueryKey = (options?: Options<GetV1RequestBusinessPartnerProxiesData>) => createQueryKey('getV1RequestBusinessPartnerProxies', options);

/**
 * List the business partner requests for new customers
 *
 *  Get the business partner request on behalf of customers (proxy requests). <hr /> <br /> <br /> Requires sa_customer_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**.
 */
export const getV1RequestBusinessPartnerProxiesOptions = (options?: Options<GetV1RequestBusinessPartnerProxiesData>) => queryOptions<GetV1RequestBusinessPartnerProxiesResponse, DefaultError, GetV1RequestBusinessPartnerProxiesResponse, ReturnType<typeof getV1RequestBusinessPartnerProxiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1RequestBusinessPartnerProxies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1RequestBusinessPartnerProxiesQueryKey(options)
});

export const getV1RequestBusinessPartnerProxiesInfiniteQueryKey = (options?: Options<GetV1RequestBusinessPartnerProxiesData>): QueryKey<Options<GetV1RequestBusinessPartnerProxiesData>> => createQueryKey('getV1RequestBusinessPartnerProxies', options, true);

/**
 * List the business partner requests for new customers
 *
 *  Get the business partner request on behalf of customers (proxy requests). <hr /> <br /> <br /> Requires sa_customer_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**.
 */
export const getV1RequestBusinessPartnerProxiesInfiniteOptions = (options?: Options<GetV1RequestBusinessPartnerProxiesData>) => {
    const opts = infiniteQueryOptions<GetV1RequestBusinessPartnerProxiesResponse, DefaultError, InfiniteData<GetV1RequestBusinessPartnerProxiesResponse>, QueryKey<Options<GetV1RequestBusinessPartnerProxiesData>>, number | Pick<QueryKey<Options<GetV1RequestBusinessPartnerProxiesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1RequestBusinessPartnerProxiesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1RequestBusinessPartnerProxies({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1RequestBusinessPartnerProxiesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create request on behalf of a customer
 *
 *  Provider creates a request for a new business partner on behalf of of a customer. <hr /> <br /> <br /> Requires sa_customer_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**. <br /> If the business partner request customer type isn't `end_customer_enterprise` or `end_customer_individual`, responds with HTTP status **400**. <br /> If the customer email identity already owns a business partner, responds with HTTP status **409**. <br /> If there is already a business partner request for the customer email identity, responds with HTTP status **409**. <br /> <br /> On success, if the business partner request is `customer_review`, responds with HTTP status **201**. On success, if the business partner request is `pending` or `accepted`, responds with HTTP status **202**. <br /> <br /> Notifications will be generated informing progress of the change request for the service provider support roles and the customer email identity. <br /> <br /> A request with status `accepted` will promptly change status to `done` and a new business partner and service agreement with the customer business partner will be created. <br /> <br /> The new service agreement will require consent from the customer email identity. <br /> <br /> A request with status `rejected` will remain until deleted or garbage collected. Requests are rejected if they appear to be duplicates. Rejected requests may be updated with new details to try again. <br /> <br /> Optionally supply `migrationCandidateBusinessPartnerId` to accept a migration candidate business partner on the customer's behalf. When supplied, the new business partner request is linked to that candidate and the candidate is accepted as a side effect. Omit it for an ordinary proxy request.
 */
export const postV1RequestBusinessPartnerProxyMutation = (options?: Partial<Options<PostV1RequestBusinessPartnerProxyData>>): UseMutationOptions<PostV1RequestBusinessPartnerProxyResponse, DefaultError, Options<PostV1RequestBusinessPartnerProxyData>> => {
    const mutationOptions: UseMutationOptions<PostV1RequestBusinessPartnerProxyResponse, DefaultError, Options<PostV1RequestBusinessPartnerProxyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1RequestBusinessPartnerProxy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a particular business partner request related to current business partner
 *
 *  Delete a particular business partner request related to current business partner. <hr /> <br /> <br /> Requires bp_admin or sa_customer_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If id does not refer to a business partner request which is: for a division of current business partner; a proxy from current business partner, responds with HTTP status **404**. <br /> If the business partner request status is not one of `rejected`, `done` or `closed`, responds with HTTP status **409**.
 */
export const deleteV1RequestBusinessPartnerByIdMutation = (options?: Partial<Options<DeleteV1RequestBusinessPartnerByIdData>>): UseMutationOptions<DeleteV1RequestBusinessPartnerByIdResponse, DefaultError, Options<DeleteV1RequestBusinessPartnerByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteV1RequestBusinessPartnerByIdResponse, DefaultError, Options<DeleteV1RequestBusinessPartnerByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1RequestBusinessPartnerById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1RequestBusinessPartnerByIdQueryKey = (options: Options<GetV1RequestBusinessPartnerByIdData>) => createQueryKey('getV1RequestBusinessPartnerById', options);

/**
 * Get a particular business partner request
 *
 *  Get a particular business partner request. <hr /> <br /> <br /> If id does not refer to a business partner request, responds with HTTP status **404**.
 */
export const getV1RequestBusinessPartnerByIdOptions = (options: Options<GetV1RequestBusinessPartnerByIdData>) => queryOptions<GetV1RequestBusinessPartnerByIdResponse, DefaultError, GetV1RequestBusinessPartnerByIdResponse, ReturnType<typeof getV1RequestBusinessPartnerByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1RequestBusinessPartnerById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1RequestBusinessPartnerByIdQueryKey(options)
});

/**
 * Update a particular business partner request
 *
 *  Update a particular business partner request. <hr /> <br /> <br /> If id does not refer to a business partner, responds with HTTP status **404**. <br /> If the business partner request status is not `rejected` or `customer_review`, responds with HTTP status **409**. <br /> <br /> On success, if business partner request was `rejected`, responds with HTTP status **202** and the status is `accepted` and the request is in progress again.
 */
export const putV1RequestBusinessPartnerByIdMutation = (options?: Partial<Options<PutV1RequestBusinessPartnerByIdData>>): UseMutationOptions<PutV1RequestBusinessPartnerByIdResponse, DefaultError, Options<PutV1RequestBusinessPartnerByIdData>> => {
    const mutationOptions: UseMutationOptions<PutV1RequestBusinessPartnerByIdResponse, DefaultError, Options<PutV1RequestBusinessPartnerByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putV1RequestBusinessPartnerById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept business partner request
 *
 *  Accept a particular business partner request <hr /> <br /> <br /> If the business partner request doesn't exist, responds with HTTP status **404**. <br /> If the business partner request status is not `customer_review`, responds with HTTP status **409**.
 */
export const postV1RequestBusinessPartnerByIdAcceptMutation = (options?: Partial<Options<PostV1RequestBusinessPartnerByIdAcceptData>>): UseMutationOptions<PostV1RequestBusinessPartnerByIdAcceptResponse, DefaultError, Options<PostV1RequestBusinessPartnerByIdAcceptData>> => {
    const mutationOptions: UseMutationOptions<PostV1RequestBusinessPartnerByIdAcceptResponse, DefaultError, Options<PostV1RequestBusinessPartnerByIdAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1RequestBusinessPartnerByIdAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decline business partner request
 *
 *  Decline a particular business partner request <hr /> <br /> <br /> If the business partner request doesn't exist, responds with HTTP status **404**. <br /> If the business partner request status is not `customer_review`, responds with HTTP status **409**.
 */
export const postV1RequestBusinessPartnerByIdDeclineMutation = (options?: Partial<Options<PostV1RequestBusinessPartnerByIdDeclineData>>): UseMutationOptions<PostV1RequestBusinessPartnerByIdDeclineResponse, DefaultError, Options<PostV1RequestBusinessPartnerByIdDeclineData>> => {
    const mutationOptions: UseMutationOptions<PostV1RequestBusinessPartnerByIdDeclineResponse, DefaultError, Options<PostV1RequestBusinessPartnerByIdDeclineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1RequestBusinessPartnerByIdDecline({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate registration token for business partner request owner
 *
 *  Generate a registration token for the owner of a business partner request. <hr /> <br /> <br /> This is authorized by the share link, so requires no permissions. <br /> The token is an HMAC-signed JWT containing the owner's email and a nonce, intended for use as the `register` parameter in the PingFederate registration invite flow. <br /> <br /> If the business partner request doesn't exist, responds with HTTP status **404**.
 */
export const postV1RequestBusinessPartnerByIdRegistrationTokenMutation = (options?: Partial<Options<PostV1RequestBusinessPartnerByIdRegistrationTokenData>>): UseMutationOptions<PostV1RequestBusinessPartnerByIdRegistrationTokenResponse, DefaultError, Options<PostV1RequestBusinessPartnerByIdRegistrationTokenData>> => {
    const mutationOptions: UseMutationOptions<PostV1RequestBusinessPartnerByIdRegistrationTokenResponse, DefaultError, Options<PostV1RequestBusinessPartnerByIdRegistrationTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1RequestBusinessPartnerByIdRegistrationToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1RequestChangeOwnershipByIdQueryKey = (options: Options<GetV1RequestChangeOwnershipByIdData>) => createQueryKey('getV1RequestChangeOwnershipById', options);

/**
 * Get the business partner for the specified change ownership request
 *
 *  Gets the business partner for the specified ChangeOwnershipRequest <br /> This is authorized by the share link, so requires no permissions.
 */
export const getV1RequestChangeOwnershipByIdOptions = (options: Options<GetV1RequestChangeOwnershipByIdData>) => queryOptions<GetV1RequestChangeOwnershipByIdResponse, DefaultError, GetV1RequestChangeOwnershipByIdResponse, ReturnType<typeof getV1RequestChangeOwnershipByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1RequestChangeOwnershipById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1RequestChangeOwnershipByIdQueryKey(options)
});

/**
 * Accepts the specified change ownership request
 *
 *  Accepts the specified change ownership request <br /> This is authorized by the share link, so requires no permissions. If the identity specified is already an owner of a business partner, or pending request business partner, responds with HTTP status **409** <br />
 */
export const postV1RequestChangeOwnershipByIdAcceptMutation = (options?: Partial<Options<PostV1RequestChangeOwnershipByIdAcceptData>>): UseMutationOptions<unknown, DefaultError, Options<PostV1RequestChangeOwnershipByIdAcceptData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostV1RequestChangeOwnershipByIdAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1RequestChangeOwnershipByIdAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1RolesCurrentQueryKey = (options?: Options<GetV1RolesCurrentData>) => createQueryKey('getV1RolesCurrent', options);

/**
 * Get the current roles (based on the token)
 */
export const getV1RolesCurrentOptions = (options?: Options<GetV1RolesCurrentData>) => queryOptions<GetV1RolesCurrentResponse, DefaultError, GetV1RolesCurrentResponse, ReturnType<typeof getV1RolesCurrentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1RolesCurrent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1RolesCurrentQueryKey(options)
});

/**
 * Create service agreement with customer
 *
 *  Create a service agreement with a business partner of a customer type `end_customer_enterprise` or `end_customer_individual`. <hr /> <br /> <br /> Requires sa_customer_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**. <br /> If the customer business partner doesn't exist, responds with HTTP status **400**. <br /> If the customer business partner type isn't `end_customer_enterprise` or `end_customer_individual`, responds with HTTP status **409**. <br /> If the customer business partner has 3 or more service agreements, responds with HTTP status **409**. <br /> If there is an existing service agreement between current business partner and stated customer business partner, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **201** and new service agreement is created between the customer and provider. <br /> <br /> The new service agreement is consented by the provider, but not by the customer. <br /> <br /> Creating a service agreement may complete migration processing for migration candidates linked to the same dealer and customer. Matching candidates with overall status `accepted` or `matched` and `service_agreement_status = pending` are moved to `service_agreement_status = accepted`. <br /> <br /> Notifications are sent to the provider and customer.
 */
export const postV1ServiceAgreementWithCustomerMutation = (options?: Partial<Options<PostV1ServiceAgreementWithCustomerData>>): UseMutationOptions<PostV1ServiceAgreementWithCustomerResponse, DefaultError, Options<PostV1ServiceAgreementWithCustomerData>> => {
    const mutationOptions: UseMutationOptions<PostV1ServiceAgreementWithCustomerResponse, DefaultError, Options<PostV1ServiceAgreementWithCustomerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1ServiceAgreementWithCustomer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create service agreement with provider
 *
 *  Create a service agreement with a ServiceProvider (dealer). <hr /> <br /> <br /> Requires sa_sp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `end_customer_individual` or `end_customer_enterprise`, responds with HTTP status **403**. <br /> If current business partner has 3 or more service agreements, responds with HTTP status **409**. <br /> If the provider business partner doesn't exist, responds with HTTP status **400**. <br /> If the provider business partner type isn't `dealer`, responds with HTTP status **409**. <br /> If there is an existing service agreement between current business partner and stated customer business partner, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **201** and new service agreement is created between the customer and provider. <br /> <br /> The new service agreement is consented by the provider, but not by the customer. <br /> <br /> Creating a service agreement may complete migration processing for migration candidates linked to the same dealer and customer. Matching candidates with overall status `accepted` or `matched` and `service_agreement_status = pending` are moved to `service_agreement_status = accepted`. <br /> <br /> Notifications are sent to the provider and customer.
 */
export const postV1ServiceAgreementWithProviderMutation = (options?: Partial<Options<PostV1ServiceAgreementWithProviderData>>): UseMutationOptions<PostV1ServiceAgreementWithProviderResponse, DefaultError, Options<PostV1ServiceAgreementWithProviderData>> => {
    const mutationOptions: UseMutationOptions<PostV1ServiceAgreementWithProviderResponse, DefaultError, Options<PostV1ServiceAgreementWithProviderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1ServiceAgreementWithProvider({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a particular service agreement
 *
 *  Delete a particular service agreement related to current business partner <hr /> <br /> <br /> Requires sa_customer_admin or sa_sp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the service agreement doesn't exist, responds with HTTP status **404**. <br /> If current business partner is not either the provider, or the customer of the service agreement, responds with HTTP status **404**.
 */
export const deleteV1ServiceAgreementByIdMutation = (options?: Partial<Options<DeleteV1ServiceAgreementByIdData>>): UseMutationOptions<DeleteV1ServiceAgreementByIdResponse, DefaultError, Options<DeleteV1ServiceAgreementByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteV1ServiceAgreementByIdResponse, DefaultError, Options<DeleteV1ServiceAgreementByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1ServiceAgreementById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1ServiceAgreementByIdQueryKey = (options: Options<GetV1ServiceAgreementByIdData>) => createQueryKey('getV1ServiceAgreementById', options);

/**
 * Get a particular service agreement
 *
 *  Get a particular service agreement related to current business partner <hr /> <br /> <br /> Requires sa_customer_admin or sa_sp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the service agreement doesn't exist, responds with HTTP status **404**. <br /> If current business partner is not either the provider, or the customer of the service agreement, responds with HTTP status **404**.
 */
export const getV1ServiceAgreementByIdOptions = (options: Options<GetV1ServiceAgreementByIdData>) => queryOptions<GetV1ServiceAgreementByIdResponse, DefaultError, GetV1ServiceAgreementByIdResponse, ReturnType<typeof getV1ServiceAgreementByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1ServiceAgreementById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1ServiceAgreementByIdQueryKey(options)
});

/**
 * Update a particular service agreement
 *
 *  Update a particular service agreement related to current business partner <hr /> <br /> <br /> Requires sa_customer_admin or sa_sp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the service agreement doesn't exist, responds with HTTP status **404**. <br /> If the upsert results in no change, responds with HTTP status **200**. <br /> <br /> Changing the terms of the service agreement will require the other party to re-consent to the service agreement. Notifications will be sent to both parties regarding the change.
 */
export const putV1ServiceAgreementByIdMutation = (options?: Partial<Options<PutV1ServiceAgreementByIdData>>): UseMutationOptions<PutV1ServiceAgreementByIdResponse, DefaultError, Options<PutV1ServiceAgreementByIdData>> => {
    const mutationOptions: UseMutationOptions<PutV1ServiceAgreementByIdResponse, DefaultError, Options<PutV1ServiceAgreementByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putV1ServiceAgreementById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept service agreement request
 *
 *  Accept a service agreement request where current business partner is the invitee <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the service agreement doesn't exist, responds with HTTP status **404**. <br /> If the service agreement status is not `invited`, responds with HTTP status **409**. <br /> If current business partner is not either the provider, or the customer of the service agreement, responds with HTTP status **404**.
 */
export const postV1ServiceAgreementByIdAcceptMutation = (options?: Partial<Options<PostV1ServiceAgreementByIdAcceptData>>): UseMutationOptions<PostV1ServiceAgreementByIdAcceptResponse, DefaultError, Options<PostV1ServiceAgreementByIdAcceptData>> => {
    const mutationOptions: UseMutationOptions<PostV1ServiceAgreementByIdAcceptResponse, DefaultError, Options<PostV1ServiceAgreementByIdAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1ServiceAgreementByIdAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decline service agreement request
 *
 *  Decline a service agreement request where current business partner is the invitee <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the service agreement doesn't exist, responds with HTTP status **404**. <br /> If the service agreement status is not `invited`, responds with HTTP status **409**. <br /> If current business partner is not either the provider, or the customer of the service agreement, responds with HTTP status **404**.
 */
export const postV1ServiceAgreementByIdDeclineMutation = (options?: Partial<Options<PostV1ServiceAgreementByIdDeclineData>>): UseMutationOptions<PostV1ServiceAgreementByIdDeclineResponse, DefaultError, Options<PostV1ServiceAgreementByIdDeclineData>> => {
    const mutationOptions: UseMutationOptions<PostV1ServiceAgreementByIdDeclineResponse, DefaultError, Options<PostV1ServiceAgreementByIdDeclineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1ServiceAgreementByIdDecline({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1ServiceAgreementsWithCustomerQueryKey = (options?: Options<GetV1ServiceAgreementsWithCustomerData>) => createQueryKey('getV1ServiceAgreementsWithCustomer', options);

/**
 * List service agreements with customers
 *
 *  List service agreements with customers of current business partner (dealer). <hr /> <br /> <br /> Requires is_sa_customer_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**. <br /> **scope** query parameter controls which providers are included: `current` (default), `children`, or `currentAndChildren`. Only immediate child providers are included; grandchildren are excluded. Parent visibility is read-only; mutations remain limited to the actual service agreement parties. <br /> **filter[providerBusinessPartnerId][in]** narrows results to the specified provider IDs within the requested scope. IDs outside the scope are silently excluded. <br /> Standard `page`, `limit`, and `filter` parameters are applied together with scope in a single combined query against Directus/PostgreSQL. `sort` is not configurable for this route; results are always ordered deterministically by provider name, then by service agreement ID as a stable tie-breaker.
 */
export const getV1ServiceAgreementsWithCustomerOptions = (options?: Options<GetV1ServiceAgreementsWithCustomerData>) => queryOptions<GetV1ServiceAgreementsWithCustomerResponse, DefaultError, GetV1ServiceAgreementsWithCustomerResponse, ReturnType<typeof getV1ServiceAgreementsWithCustomerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1ServiceAgreementsWithCustomer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1ServiceAgreementsWithCustomerQueryKey(options)
});

export const getV1ServiceAgreementsWithCustomerInfiniteQueryKey = (options?: Options<GetV1ServiceAgreementsWithCustomerData>): QueryKey<Options<GetV1ServiceAgreementsWithCustomerData>> => createQueryKey('getV1ServiceAgreementsWithCustomer', options, true);

/**
 * List service agreements with customers
 *
 *  List service agreements with customers of current business partner (dealer). <hr /> <br /> <br /> Requires is_sa_customer_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**. <br /> **scope** query parameter controls which providers are included: `current` (default), `children`, or `currentAndChildren`. Only immediate child providers are included; grandchildren are excluded. Parent visibility is read-only; mutations remain limited to the actual service agreement parties. <br /> **filter[providerBusinessPartnerId][in]** narrows results to the specified provider IDs within the requested scope. IDs outside the scope are silently excluded. <br /> Standard `page`, `limit`, and `filter` parameters are applied together with scope in a single combined query against Directus/PostgreSQL. `sort` is not configurable for this route; results are always ordered deterministically by provider name, then by service agreement ID as a stable tie-breaker.
 */
export const getV1ServiceAgreementsWithCustomerInfiniteOptions = (options?: Options<GetV1ServiceAgreementsWithCustomerData>) => {
    const opts = infiniteQueryOptions<GetV1ServiceAgreementsWithCustomerResponse, DefaultError, InfiniteData<GetV1ServiceAgreementsWithCustomerResponse>, QueryKey<Options<GetV1ServiceAgreementsWithCustomerData>>, number | Pick<QueryKey<Options<GetV1ServiceAgreementsWithCustomerData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1ServiceAgreementsWithCustomerData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1ServiceAgreementsWithCustomer({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1ServiceAgreementsWithCustomerInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getV1ServiceAgreementsWithProviderQueryKey = (options?: Options<GetV1ServiceAgreementsWithProviderData>) => createQueryKey('getV1ServiceAgreementsWithProvider', options);

/**
 * List service agreements with service providers (dealers)
 *
 *  List service agreement with service providers (dealers) for current business partner. <hr /> <br /> <br /> Requires sa_sp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `end_customer_enterprise` or `end_customer_individual`, responds with HTTP status **403**.
 */
export const getV1ServiceAgreementsWithProviderOptions = (options?: Options<GetV1ServiceAgreementsWithProviderData>) => queryOptions<GetV1ServiceAgreementsWithProviderResponse, DefaultError, GetV1ServiceAgreementsWithProviderResponse, ReturnType<typeof getV1ServiceAgreementsWithProviderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1ServiceAgreementsWithProvider({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1ServiceAgreementsWithProviderQueryKey(options)
});

export const getV1ServiceAgreementsWithProviderInfiniteQueryKey = (options?: Options<GetV1ServiceAgreementsWithProviderData>): QueryKey<Options<GetV1ServiceAgreementsWithProviderData>> => createQueryKey('getV1ServiceAgreementsWithProvider', options, true);

/**
 * List service agreements with service providers (dealers)
 *
 *  List service agreement with service providers (dealers) for current business partner. <hr /> <br /> <br /> Requires sa_sp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `end_customer_enterprise` or `end_customer_individual`, responds with HTTP status **403**.
 */
export const getV1ServiceAgreementsWithProviderInfiniteOptions = (options?: Options<GetV1ServiceAgreementsWithProviderData>) => {
    const opts = infiniteQueryOptions<GetV1ServiceAgreementsWithProviderResponse, DefaultError, InfiniteData<GetV1ServiceAgreementsWithProviderResponse>, QueryKey<Options<GetV1ServiceAgreementsWithProviderData>>, number | Pick<QueryKey<Options<GetV1ServiceAgreementsWithProviderData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1ServiceAgreementsWithProviderData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1ServiceAgreementsWithProvider({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1ServiceAgreementsWithProviderInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};
